import activity from './locales/js/activity.fr.js';
import analytics from './locales/js/analytics.fr.js';
import announcement from './locales/js/announcement.fr.js';
import building from './locales/js/building.fr.js';
import button from './locales/js/button.fr.js';
import client from './locales/js/client.fr.js';
import company from './locales/js/company.fr.js';
import constants from './locales/js/constants.fr.js';
import contact from './locales/js/contact.fr.js';
import countries from './locales/js/countries.fr.js';
import customer from './locales/js/customer.fr.js';
import decision from './locales/js/decision.fr.js';
import decision_type from './locales/js/decision_type.fr.js';
import document from './locales/js/document.fr.js';
import dropzone from './locales/js/dropzone.fr.js';
import editor_ziggu from './locales/js/editor_ziggu.fr.js';
import employee from './locales/js/employee.fr.js';
import form from './locales/js/form.fr.js';
import inspiration from './locales/js/inspiration.fr.js';
import inspiration_list from './locales/js/inspiration_list.fr.js';
import installment from './locales/js/installment.fr.js';
import installment_term from './locales/js/installment_term.fr.js';
import integration from './locales/js/integration.fr.js';
import integration_error from './locales/js/integration_error.fr.js';
import issue from './locales/js/issue.fr.js';
import issue_category from './locales/js/issue_category.fr.js';
import issue_list from './locales/js/issue_list.fr.js';
import issue_status from './locales/js/issue_status.fr.js';
import lead from './locales/js/lead.fr.js';
import levels from './locales/js/levels.fr.js';
import lot from './locales/js/lot.fr.js';
import message from './locales/js/message.fr.js';
import milestone from './locales/js/milestone.fr.js';
import modal from './locales/js/modal.fr.js';
import navbar from './locales/js/navbar.fr.js';
import notification from './locales/js/notification.fr.js';
import pages from './locales/js/pages.fr.js';
import partner from './locales/js/partner.fr.js';
import phase from './locales/js/phase.fr.js';
import profile from './locales/js/profile.fr.js';
import project from './locales/js/project.fr.js';
import proposal from './locales/js/proposal.fr.js';
import question from './locales/js/question.fr.js';
import question_list from './locales/js/question_list.fr.js';
import reminder from './locales/js/reminder.fr.js';
import sales from './locales/js/sales.fr.js';
import select from './locales/js/select.fr.js';
import session from './locales/js/session.fr.js';
import signature from './locales/js/signature.fr.js';
import space from './locales/js/space.fr.js';
import subscription from './locales/js/subscription.fr.js';
import survey from './locales/js/survey.fr.js';
import survey_type from './locales/js/survey_type.fr.js';
import tenant from './locales/js/tenant.fr.js';
import ticket from './locales/js/ticket.fr.js';
import timestamp from './locales/js/timestamp.fr.js';
import toast from './locales/js/toast.fr.js';
import todo from './locales/js/todo.fr.js';
import todo_list from './locales/js/todo_list.fr.js';
import unit from './locales/js/unit.fr.js';
import upsell from './locales/js/upsell.fr.js';
import validation from './locales/js/validation.fr.js';
import window from './locales/js/window.fr.js';

export default {
  fr: {
    ...activity.fr,
    ...analytics.fr,
    ...announcement.fr,
    ...building.fr,
    ...button.fr,
    ...client.fr,
    ...company.fr,
    ...constants.fr,
    ...contact.fr,
    ...countries.fr,
    ...customer.fr,
    ...decision.fr,
    ...decision_type.fr,
    ...document.fr,
    ...dropzone.fr,
    ...editor_ziggu.fr,
    ...employee.fr,
    ...form.fr,
    ...inspiration.fr,
    ...inspiration_list.fr,
    ...installment.fr,
    ...installment_term.fr,
    ...integration.fr,
    ...integration_error.fr,
    ...issue.fr,
    ...issue_category.fr,
    ...issue_list.fr,
    ...issue_status.fr,
    ...lead.fr,
    ...levels.fr,
    ...lot.fr,
    ...message.fr,
    ...milestone.fr,
    ...modal.fr,
    ...navbar.fr,
    ...notification.fr,
    ...pages.fr,
    ...partner.fr,
    ...phase.fr,
    ...profile.fr,
    ...project.fr,
    ...proposal.fr,
    ...question.fr,
    ...question_list.fr,
    ...reminder.fr,
    ...sales.fr,
    ...select.fr,
    ...session.fr,
    ...signature.fr,
    ...space.fr,
    ...subscription.fr,
    ...survey.fr,
    ...survey_type.fr,
    ...tenant.fr,
    ...ticket.fr,
    ...timestamp.fr,
    ...toast.fr,
    ...todo.fr,
    ...todo_list.fr,
    ...unit.fr,
    ...upsell.fr,
    ...validation.fr,
    ...window.fr,
  },
};
